"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("./errors");
const types_1 = require("../types");
const version_1 = require("../version");
const DEFAULT_REQUEST_TIMEOUT_MS = 2000;
const PROD_BASE_URL = 'https://api.atlassian.com/flags';
const STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
const DEV_BASE_URL = 'https://api.dev.atlassian.com/flags';
const GATEWAY_BASE_URL = '/gateway/api/flags';
class Fetcher {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        }
        catch (error) {
            if (error instanceof Error) {
                throw error;
            }
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers,
            customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        }
        catch (error) {
            if (error instanceof Error) {
                throw error;
            }
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new errors_1.ResponseError(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) {
            throw new errors_1.ResponseError('Unexpected 204 response');
        }
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false) {
        if (useGatewayUrl) {
            return GATEWAY_BASE_URL;
        }
        switch (serviceEnv) {
            case types_1.FeatureGateEnvironment.Development:
                return DEV_BASE_URL;
            case types_1.FeatureGateEnvironment.Staging:
                return STAGING_BASE_URL;
            default:
                return PROD_BASE_URL;
        }
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) {
            abortSignal = AbortSignal.timeout(fetchTimeout);
        }
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(() => abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, Object.assign({ method, headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': version_1.CLIENT_VERSION,
                'X-API-KEY': fetcherOptions.apiKey
            }, signal: abortSignal }, (body && { body: JSON.stringify(body) })));
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
}
exports.default = Fetcher;
